import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MdRadioModule} from '@angular/material';
import {InterpreterBoxComponent} from './interpreter-box.component';

@NgModule({
  imports: [CommonModule, FormsModule, MdRadioModule],
  declarations: [InterpreterBoxComponent],
  exports: [InterpreterBoxComponent],
})
export class InterpreterBoxModule {}



// WEBPACK FOOTER //
// ./src/app/shared/ui/interpreter-box/interpreter-box.module.ts